import { STAKEHOLDER_CASETAFEL_REPRESENTATIVE } from '../../constants/dossier.constants';
import { PERMISSIONS } from '../../constants/permissions.constants';

const _isInvolved = (item, user) => {
  return !!item?.involved?.find((i) => i?.id === user?.contactId);
};

const toClarificationPermissions = (clarification, permissions = {}, user) => {
  let { read, write, writeOnlyIfStakeholder } = permissions;
  if (writeOnlyIfStakeholder) {
    write = _isInvolved(clarification, user);
  }
  return { read, write };
};

const toCasetafelPermissions = (casetafel, permissions, user) => {
  const isRepresentative = !!casetafel?.involved?.find(
    (i) => i?.role === STAKEHOLDER_CASETAFEL_REPRESENTATIVE && i?.id === user.contactId
  );
  const hasAnyRole = [
    PERMISSIONS.STAD_DISPATCH,
    PERMISSIONS.STAD_ADMIN,
    PERMISSIONS.PARTNER_ADMIN,
    PERMISSIONS.PARTNER_MEDEWERKER,
    PERMISSIONS.PARTNER_NIET_FREQUENT,
    PERMISSIONS.SCHOOL_ADMIN,
    PERMISSIONS.SCHOOL_MEDEWERKER,
    PERMISSIONS.SCHOOL_NET_ADMIN,
    PERMISSIONS.SCHOOL_NET_BEGELEIDER
  ]?.some((permission) => user?.permissions?.includes(permission));
  if (isRepresentative && hasAnyRole) {
    return { read: true, write: true };
  }

  const readReportOnly = [
    PERMISSIONS.SCHOOL_ADMIN,
    PERMISSIONS.SCHOOL_MEDEWERKER,
    PERMISSIONS.SCHOOL_NET_ADMIN,
    PERMISSIONS.SCHOOL_NET_BEGELEIDER
  ]?.some((permission) => user?.permissions?.includes(permission));
  const writeApproveAndQuestionnaireOnly = readReportOnly && _isInvolved(casetafel, user);
  let { read, write, writeOnlyIfStakeholder } = permissions;
  if (writeOnlyIfStakeholder) {
    write = _isInvolved(casetafel, user);
  }
  return { read, write, readReportOnly, writeApproveAndQuestionnaireOnly };
};

const toCommissionPermissions = toCasetafelPermissions;

const toProcedurePermissions = toClarificationPermissions;

const dossierTabsPermissionsService = {
  toClarificationPermissions,
  toCasetafelPermissions,
  toCommissionPermissions,
  toProcedurePermissions
};

export default dossierTabsPermissionsService;
